import styled from "styled-components";

export const CompanionsWrapper = styled.div`
  padding: 5rem 0;
  border: 3px solid var(--field-color);
  border-radius: 16px;
  @media screen and (max-width: 576px) {
    padding: 3rem 0 1.5rem;
  }
`;

export const SectionTitleH3 = styled.h3`
  padding: 1.5rem 3.5rem;
  white-space: nowrap;
  @media screen and (max-width: 768px) {
    padding: 1rem 1.5rem;
    font-size: var(--font-size-base);
  }
  color: var(--white-color);
  background-color: var(--primary-color);
  border: var(--blue-color-light) 14px solid;
  border-radius: 80px;
  font-size: var(--font-size-xl);
  max-width: 90%;
  top: -53px;
  left: 50%;
  transform: translateX(-50%);
`;

export const CompanionImgWrapper = styled.div`
  width: 200px;
  height: 170px;
  @media screen and (max-width: 768px) {
    width: 94px;
    height: 129px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SingleCompanionCard = styled.a`
  background: var(--white-color);
  color: var(--text-color-dark);
  width: 100%;
  max-height: 250px;
  border-radius: 16px;
  box-shadow: rgba(62, 165, 219, 0.07) 0px 7px 30px;
  display: grid;
  align-items: center;
  justify-items: center;
  grid-template-rows: 2fr 1fr;
  h5 {
    font-size: var(--font-size-base);
    line-height: 1.5rem;
    max-width: 85%;
    @media screen and (max-width: 576px) {
      font-size: 10px;
    }
  }
`;
